(function () {
  'use strict';
  var C = window.HypdCart;
  var root = document.querySelector('[data-bundle-picker]');
  if (!root) return;

  var sectionId = root.dataset.sectionId;
  var sectionSel = '#shopify-section-' + sectionId;
  var footerId = 'BundleFooter-' + sectionId;
  var storageKey = 'hypd_bundle_' + sectionId;
  var hdr = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function foot() { return document.getElementById(footerId); }
  function q(s, x) { return (x || document).querySelector(s); }
  function qa(s, x) { return Array.prototype.slice.call((x || document).querySelectorAll(s)); }
  function money(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
  function parseMoneyTextToCents(text) {
    if (!text) return 0;
    var digits = String(text).replace(/[^\d]/g, '');
    if (!digits) return 0;
    return +digits * 100;
  }
  function priceFromEl(el) {
    if (!el) return 0;
    return parseMoneyTextToCents(el.textContent);
  }
  function tip(m) {
    var b = document.querySelector('body-element');
    (b && b.showNotification) ? b.showNotification(m, 'warning') : alert(m);
  }
  function runBundleConfetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvas = document.getElementById('hypd-bundle-confetti');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'hypd-bundle-confetti';
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:100020;';
      document.body.appendChild(canvas);
    }
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = window.devicePixelRatio || 1;
    var w = window.innerWidth;
    var h = window.innerHeight;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var colors = ['#111111', '#c9a227', '#ffffff', '#e53935', '#2e7d32', '#1565c0'];
    var particles = [];
    var i;
    var count = Math.min(140, Math.round(w / 4));
    for (i = 0; i < count; i++) {
      particles.push({
        x: w * 0.5 + (Math.random() - 0.5) * w * 0.35,
        y: h * 0.58,
        vx: (Math.random() - 0.5) * 16,
        vy: Math.random() * -16 - 5,
        size: Math.random() * 7 + 4,
        rot: Math.random() * 360,
        vr: (Math.random() - 0.5) * 10,
        color: colors[Math.floor(Math.random() * colors.length)],
        rect: Math.random() > 0.45,
        life: Math.random() * 70 + 90,
      });
    }
    var frame = 0;
    function tick() {
      ctx.clearRect(0, 0, w, h);
      var alive = false;
      particles.forEach(function (p) {
        if (p.life <= 0) return;
        alive = true;
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.38;
        p.vx *= 0.985;
        p.rot += p.vr;
        p.life -= 1;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rot * Math.PI) / 180);
        ctx.fillStyle = p.color;
        if (p.rect) ctx.fillRect(-p.size * 0.5, -p.size * 0.25, p.size, p.size * 0.5);
        else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size * 0.5, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      });
      frame += 1;
      if (alive && frame < 150) requestAnimationFrame(tick);
      else ctx.clearRect(0, 0, w, h);
    }
    requestAnimationFrame(tick);
  }
  function celebrateIfBundleComplete(beforeCount) {
    if (beforeCount < active.count && picked.length === active.count) runBundleConfetti();
  }

  function readTiers() {
    var t = [];
    for (var i = 1; i <= 3; i++) {
      if (root.getAttribute('data-tier-' + i + '-enabled') === 'true') {
        t.push({ id: i, count: +root.getAttribute('data-tier-' + i + '-count') || 3, fixedPrice: +root.getAttribute('data-tier-' + i + '-price') || 0 });
      }
    }
    return t.length ? t : [{ id: 1, count: 3, fixedPrice: 69900 }];
  }

  var tiers = readTiers();
  var active = tiers.find(function (t) { return t.id === (+root.dataset.defaultTier || tiers[0].id); }) || tiers[0];
  var unit = root.dataset.unitLabel || 'Items';
  var prefix = root.dataset.headingPrefix || 'Pick Any';
  var col = root.dataset.bundleCollection || 'bundles';
  var bundlePopup = root.dataset.bundlePopup === 'true';
  var picked = [];
  var scrollRaf = false;

  function persist() {
    try { sessionStorage.setItem(storageKey, JSON.stringify({ tierId: active.id, items: picked })); } catch (e) {}
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(storageKey);
      if (!raw) return;
      var d = JSON.parse(raw);
      if (d.tierId) { var t = tiers.find(function (x) { return x.id === d.tierId; }); if (t) active = t; }
      if (Array.isArray(d.items)) picked = d.items.slice(0, active.count);
    } catch (e) {}
  }
  function cardPriceCents(card) {
    if (!card) return 0;
    var el = card.querySelector('.product-card__price-cost .product-card__price-item:not(.product-card__price-item-old)');
    var fromDom = priceFromEl(el);
    if (fromDom > 0) return fromDom;
    return +(card.getAttribute('data-product-price') || card.dataset.productPrice) || 0;
  }
  function cardComparePriceCents(card) {
    if (!card) return 0;
    var selectors = [
      '.product-card__price-item-old',
      '.product-card__price-item--old',
      '.product-card__price-cost [class*="price-item-old"]',
      '.product-card__price-cost [class*="price-item--old"]',
    ];
    var i;
    for (i = 0; i < selectors.length; i++) {
      var el = card.querySelector(selectors[i]);
      var fromDom = priceFromEl(el);
      if (fromDom > 0) return fromDom;
    }
    return +(card.getAttribute('data-product-compare-price') || card.dataset.productComparePrice) || 0;
  }
  function itemCompareAtPrice(sp, mrp) {
    sp = +(sp || 0);
    mrp = +(mrp || 0);
    return mrp > sp ? mrp : sp;
  }
  function pickedItemMrpCents(item) {
    if (!item) return 0;
    var card = q(sectionSel + ' product-card[data-product-id="' + item.productId + '"]');
    var sp = +(item.price || 0) || cardPriceCents(card);
    var mrp = cardComparePriceCents(card) || +(item.compareAtPrice || 0);
    return itemCompareAtPrice(sp, mrp);
  }
  function productPickCount(productId) {
    var c = 0;
    var i;
    for (i = 0; i < picked.length; i++) {
      if (String(picked[i].productId) === String(productId)) c++;
    }
    return c;
  }
  function removeLastPickedForProduct(productId) {
    var i;
    for (i = picked.length - 1; i >= 0; i--) {
      if (String(picked[i].productId) === String(productId)) {
        picked.splice(i, 1);
        return true;
      }
    }
    return false;
  }
  function cardProductId(card) {
    return card && String(card.getAttribute('data-product-id') || card.dataset.productId || '');
  }
  function cardProduct(card) {
    if (!card) return null;
    var vel = q('[data-product-form-variant]', card) || q('input[name="id"]', card);
    var vid = card.getAttribute('data-variant-id') || card.dataset.variantId || (vel && vel.value);
    if (!vid) return null;
    var img = card.querySelector('img');
    return {
      productId: String(card.getAttribute('data-product-id') || card.dataset.productId || card.dataset.id),
      variantId: String(vid),
      price: cardPriceCents(card),
      compareAtPrice: itemCompareAtPrice(cardPriceCents(card), cardComparePriceCents(card)),
      title: card.getAttribute('data-product-title') || '',
      image: card.getAttribute('data-product-image') || card.dataset.productImage || (img && (img.currentSrc || img.src)) || '',
    };
  }
  function syncBar() {
    var f = foot();
    if (f && f.offsetHeight > 0) document.documentElement.style.setProperty('--bundle-bar-height', f.offsetHeight + 'px');
  }
  function dock() {
    var f = foot();
    if (f) syncBar();
  }
  function setHead(t) {
    var el = q(sectionSel + ' [data-bundle-heading]');
    if (el && t) el.textContent = prefix + ' ' + t.count + ' ' + unit + ' — Just ₹' + Math.round(t.fixedPrice / 100).toLocaleString('en-IN');
  }
  function slotsHtml(n) {
    var h = '';
    for (var i = 0; i < n; i++) {
      if (i) h += '<span class="bundle-picker__slot-sep" aria-hidden="true">+</span>';
      var it = picked[i];
      if (it && it.image) {
        h += '<div class="bundle-picker__slot-wrap"><div class="bundle-picker__slot bundle-picker__slot--filled"><img src="' + it.image.replace(/"/g, '&quot;') + '" alt="" width="200" height="200" loading="lazy"></div><button type="button" class="bundle-picker__slot-remove" data-bundle-remove="' + i + '" aria-label="Remove">×</button></div>';
      } else {
        h += '<div class="bundle-picker__slot"><span class="bundle-picker__slot-empty" aria-hidden="true">+</span></div>';
      }
    }
    return h;
  }
  function paint() {
    var f = foot();
    if (!f) return;
    var max = active.count;
    var n = picked.length;
    var sub = picked.reduce(function (s, p) { return s + (p.price || 0); }, 0);
    var mrpSub = picked.reduce(function (s, p) { return s + pickedItemMrpCents(p); }, 0);
    var ok = n === max;
    var fin = ok ? active.fixedPrice : sub;
    var cs = q('[data-bundle-count-slot]', f);
    if (cs) cs.textContent = String(n);
    qa('[data-bundle-max]', f).forEach(function (el) { el.textContent = String(max); });
    var subT = money(sub);
    qa('[data-bundle-final]', f).forEach(function (el) {
      if (ok) el.textContent = money(active.fixedPrice);
      else if (n === 0) el.textContent = money(0);
      else el.textContent = subT;
    });
    var pr = q('[data-bundle-pricing]', f);
    if (pr) pr.classList.toggle('bundle-picker__pricing--complete', ok && mrpSub > fin);
    var o = q('[data-bundle-original]', f);
    var sv = q('[data-bundle-save]', f);
    if (o) { if (ok && mrpSub > fin) { o.textContent = money(mrpSub); o.hidden = false; } else o.hidden = true; }
    if (sv) {
      var pct = ok && mrpSub > fin ? Math.round(((mrpSub - fin) / mrpSub) * 100) : 0;
      if (pct > 0) { sv.textContent = 'Save ' + pct + '%'; sv.hidden = false; } else sv.hidden = true;
    }
    var btn = q('[data-bundle-checkout]', f);
    if (btn) { btn.disabled = !ok; btn.classList.toggle('bundle-picker__checkout--ready', ok); }
    var prog = f && q('[data-bundle-progress-label]', f);
    if (prog) {
      if (ok) prog.hidden = true;
      else { var left = max - n; prog.hidden = false; prog.textContent = left === 1 ? 'Add 1 more for ' + money(active.fixedPrice) + ' bundle' : 'Add ' + left + ' more for ' + money(active.fixedPrice) + ' bundle'; }
    }
    var completeLbl = f && q('[data-bundle-complete-label]', f);
    if (completeLbl) completeLbl.hidden = !ok;
    var sl = q('[data-bundle-slots]', f);
    if (sl) {
      sl.innerHTML = slotsHtml(max);
      sl.setAttribute('data-slot-count', String(max));
      sl.scrollLeft = 0;
      sl.style.setProperty('--bundle-slot-size', '45px');
    }
    dock();
    var full = picked.length >= active.count;
    qa(sectionSel + ' [data-bundle-card], ' + sectionSel + ' product-card[data-bundle-card]').forEach(function (card) {
      var pid = cardProductId(card);
      var count = productPickCount(pid);
      var addWrap = card.querySelector('[data-bundle-add-wrap]');
      var qtyWrap = card.querySelector('[data-bundle-qty]');
      var addBtn = card.querySelector('[data-bundle-add-btn]');
      var qtyCount = card.querySelector('[data-bundle-qty-count]');
      var minusBtn = card.querySelector('[data-bundle-qty-minus]');
      var plusBtn = card.querySelector('[data-bundle-qty-plus]');

      card.classList.toggle('is-in-bundle', count > 0);

      if (count > 0 && qtyWrap && addWrap) {
        addWrap.hidden = true;
        qtyWrap.hidden = false;
        if (qtyCount) qtyCount.textContent = String(count);
        if (minusBtn) minusBtn.disabled = false;
        if (plusBtn) plusBtn.disabled = full;
      } else if (addWrap && qtyWrap) {
        addWrap.hidden = false;
        qtyWrap.hidden = true;
        if (addBtn) addBtn.disabled = full;
      }
    });
    syncQvAddBtn();
  }
  function setTier(id) {
    var t = tiers.find(function (x) { return x.id === id; });
    if (!t) return;
    active = t;
    if (picked.length > t.count) picked = picked.slice(0, t.count);
    qa(sectionSel + ' [data-bundle-tier]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-bundle-tier') === String(id) ? 'true' : 'false'); });
    setHead(active);
    persist();
    paint();
  }
  function add(card) {
    var cardBtn = card && card.querySelector('.product-card__info [data-bundle-add-btn]');
    if (cardBtn && cardBtn.disabled) return;
    var p = cardProduct(card);
    if (!p || !p.variantId) return tip('Could not add this product. Please refresh the page.');
    if (picked.length >= active.count) return tip('You can only add ' + active.count + ' items to this bundle.');
    var before = picked.length;
    picked.push(p);
    persist();
    paint();
    celebrateIfBundleComplete(before);
  }
  function qvVariantCents(qv) {
    var form = qv.querySelector('product-form[data-product-id]');
    var pid = form && form.getAttribute('data-product-id');
    var vel = qv.querySelector('[data-product-form-variant], input[name="id"]');
    var vid = vel && vel.value;
    if (vid && window.Shopify && window.Shopify.analytics && window.Shopify.analytics.meta && window.Shopify.analytics.meta.product) {
      var vars = window.Shopify.analytics.meta.product.variants;
      if (vars) {
        for (var i = 0; i < vars.length; i++) {
          if (String(vars[i].id) === String(vid) && vars[i].price != null) return +vars[i].price;
        }
      }
    }
    var current = qv.querySelector('.product-price__current-price');
    var fromDom = priceFromEl(current);
    if (fromDom > 0) return fromDom;
    var card = pid ? q(sectionSel + ' product-card[data-product-id="' + pid + '"]') : null;
    return card ? cardPriceCents(card) : 0;
  }
  function qvSoldOutLabel() {
    var s = window.auroraThemeLocales && window.auroraThemeLocales.variantStrings;
    return (s && s.soldOut) || 'Sold out';
  }
  function qvSelectedVariant(qv) {
    if (!qv) return null;
    var picker = qv.querySelector('variant-picker');
    var jsonEl = picker && picker.querySelector('[data-variant-picker-variants]');
    if (!jsonEl) return null;
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
    var vel = qv.querySelector('[data-product-form-variant], input[name="id"]');
    var vid = vel && vel.value;
    if (!vid) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(vid)) return variants[i];
    }
    return null;
  }
  function qvVariantAvailable(qv) {
    var v = qvSelectedVariant(qv);
    return !!(v && v.available);
  }
  function qvHasAnyAvailableVariant(qv) {
    var picker = qv.querySelector('variant-picker');
    var jsonEl = picker && picker.querySelector('[data-variant-picker-variants]');
    if (!jsonEl) return qvVariantAvailable(qv);
    try {
      var variants = JSON.parse(jsonEl.textContent);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) return true;
      }
      return false;
    } catch (e) {
      return qvVariantAvailable(qv);
    }
  }
  function qvProductId(qv) {
    var form = qv && qv.querySelector('product-form[data-product-id]');
    return form ? String(form.getAttribute('data-product-id')) : '';
  }
  function qvProductMarkedSoldOut(qv) {
    var pid = qvProductId(qv);
    if (!pid) return false;
    var card = q(sectionSel + ' product-card[data-product-id="' + pid + '"]');
    if (card && card.getAttribute('data-bundle-product-available') === 'false') return true;
    var form = qv.querySelector('product-form[data-product-id]');
    if (form && form.getAttribute('data-product-available') === 'false') return true;
    return false;
  }
  function qvBundleCanAdd(qv) {
    if (qvProductMarkedSoldOut(qv)) return false;
    return qvHasAnyAvailableVariant(qv) && qvVariantAvailable(qv);
  }
  function bindBundleQvVariantSync(qv) {
    if (!qv || qv.dataset.hypdBundleQvVariantBound === '1') return;
    qv.dataset.hypdBundleQvVariantBound = '1';
    qv.addEventListener(
      'change',
      function (e) {
        if (!qv.classList.contains('hypd-bundle-quick-view')) return;
        if (
          e.target.closest('variant-picker') ||
          (e.target.matches && e.target.matches('[data-product-form-variant], input[name="id"]'))
        ) {
          syncQvAddBtn();
        }
      },
      true
    );
  }
  function addFromQuickView() {
    var qv = document.getElementById('Quick-view');
    if (!qv) return;
    var form = qv.querySelector('product-form[data-product-id]');
    if (!form) return tip('Could not add this product. Please refresh the page.');
    var pid = String(form.getAttribute('data-product-id'));
    var vel = qv.querySelector('[data-product-form-variant], input[name="id"]');
    var vid = vel && vel.value;
    if (!vid) return tip('Please select a size or variant.');
    if (!qvBundleCanAdd(qv)) return tip(qvSoldOutLabel() + ' — please choose another size or product.');
    var card = q(sectionSel + ' product-card[data-product-id="' + pid + '"]');
    if (card) card.setAttribute('data-variant-id', vid);
    var img = qv.querySelector('.quick-view__media img.is-active, .quick-view__media img, product-media img');
    var titleEl = qv.querySelector('.product__title, .h2, [data-product-title]');
    var p = {
      productId: pid,
      variantId: String(vid),
      price: qvVariantCents(qv),
      compareAtPrice: itemCompareAtPrice(
        qvVariantCents(qv),
        priceFromEl(qv.querySelector('.product-price__old-price')) || cardComparePriceCents(card)
      ),
      title: titleEl ? titleEl.textContent.trim() : (card && card.getAttribute('data-product-title')) || '',
      image: (img && (img.currentSrc || img.src)) || (card && card.getAttribute('data-product-image')) || '',
    };
    if (picked.length >= active.count) return tip('You can only add ' + active.count + ' items to this bundle.');
    var before = picked.length;
    picked.push(p);
    persist();
    paint();
    celebrateIfBundleComplete(before);
    syncQvAddBtn();
    if (typeof qv.hide === 'function') qv.hide().catch(function () {});
  }
  function bundleAddLabel() {
    return root.dataset.bundleAddLabel || 'Add to box';
  }
  var sizeModalState = { card: null, product: null, selectedVariant: null, chartLoaded: false };
  function sizeModalEl() { return q(sectionSel + ' [data-bundle-size-modal]'); }
  function sizeChartDrawer() { return q(sectionSel + ' [data-bundle-size-chart-drawer]'); }
  function sizeChartOverlay() { return q(sectionSel + ' [data-bundle-chart-overlay]'); }
  function closeSizeChartDrawer() {
    var drawer = sizeChartDrawer();
    var overlay = sizeChartOverlay();
    var modal = sizeModalEl();
    if (drawer) {
      drawer.classList.remove('is-opened');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.hidden = true;
    document.documentElement.classList.remove('hypd-bundle-size-chart-open');
    var link = q('[data-bundle-size-chart-link]', sizeModalEl());
    if (link) link.setAttribute('aria-expanded', 'false');
    if (modal && sizeModalState.card) modal.hidden = false;
  }
  function openSizeChartDrawer(card) {
    var tpl = card && q('[data-bundle-size-chart]', card);
    var drawer = sizeChartDrawer();
    var content = drawer && q('[data-bundle-size-chart-content]', drawer);
    var overlay = sizeChartOverlay();
    var modal = sizeModalEl();
    if (!tpl || !drawer || !content) return tip('Size chart unavailable.');
    content.innerHTML = tpl.innerHTML;
    if (modal) modal.hidden = true;
    document.documentElement.classList.add('hypd-bundle-size-chart-open');
    drawer.classList.add('is-opened');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    var link = q('[data-bundle-size-chart-link]', sizeModalEl());
    if (link) link.setAttribute('aria-expanded', 'true');
    sizeModalState.chartLoaded = true;
  }
  function closeSizeModal() {
    var modal = sizeModalEl();
    if (!modal) return;
    closeSizeChartDrawer();
    modal.hidden = true;
    document.documentElement.classList.remove('hypd-bundle-size-modal-open');
    sizeModalState = { card: null, product: null, selectedVariant: null, chartLoaded: false };
    var chartLink = q('[data-bundle-size-chart-link]', modal);
    var options = q('[data-bundle-size-modal-options]', modal);
    if (chartLink) chartLink.hidden = true;
    if (options) options.innerHTML = '';
  }
  function getSizeOptionIndex(product) {
    var opts = product.options || [];
    var i;
    for (i = 0; i < opts.length; i++) {
      if (String(opts[i]).toLowerCase() === 'size') return i;
    }
    return opts.length === 1 ? 0 : opts.length - 1;
  }
  function findVariantForSize(product, card, sizeValue, sizeIdx) {
    var key = 'option' + (sizeIdx + 1);
    var cardVid = card && (card.getAttribute('data-variant-id') || card.dataset.variantId);
    var base = null;
    var i;
    if (cardVid) {
      for (i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(cardVid)) {
          base = product.variants[i];
          break;
        }
      }
    }
    if (!base) base = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    for (i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant[key] !== sizeValue) continue;
      var match = true;
      var o;
      for (o = 0; o < (product.options || []).length; o++) {
        if (o === sizeIdx) continue;
        var optKey = 'option' + (o + 1);
        if (base && variant[optKey] !== base[optKey]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }
  function getVariantImage(variant, product, card) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (product && product.featured_image) return product.featured_image;
    return (card && (card.getAttribute('data-product-image') || card.dataset.productImage)) || '';
  }
  function addVariantToBundle(variant, product, card) {
    if (!variant || !product) return;
    if (picked.length >= active.count) return tip('You can only add ' + active.count + ' items to this bundle.');
    var before = picked.length;
    picked.push({
      productId: String(product.id),
      variantId: String(variant.id),
      price: +(variant.price || 0),
      compareAtPrice: itemCompareAtPrice(variant.price, cardComparePriceCents(card) || variant.compare_at_price),
      title: product.title || (card && card.getAttribute('data-product-title')) || '',
      image: getVariantImage(variant, product, card),
    });
    persist();
    paint();
    celebrateIfBundleComplete(before);
    closeSizeModal();
  }
  function selectSizeVariant(variant, btn) {
    sizeModalState.selectedVariant = variant || null;
    var modal = sizeModalEl();
    if (!modal) return;
    qa('[data-bundle-size-modal-options] .bundle-picker__size-option', modal).forEach(function (el) {
      el.classList.toggle('is-selected', el === btn);
    });
    var addBtn = q('[data-bundle-size-modal-add]', modal);
    if (addBtn) addBtn.disabled = !(variant && variant.available);
  }
  function renderSizeModalOptions(product, card) {
    var modal = sizeModalEl();
    if (!modal || !product) return;
    var optionsEl = q('[data-bundle-size-modal-options]', modal);
    var addBtn = q('[data-bundle-size-modal-add]', modal);
    if (!optionsEl) return;
    optionsEl.innerHTML = '';
    sizeModalState.selectedVariant = null;
    if (addBtn) addBtn.disabled = true;

    if (product.variants.length === 1) {
      var only = product.variants[0];
      optionsEl.innerHTML = '<button type="button" class="bundle-picker__size-option is-selected" disabled>One size</button>';
      sizeModalState.selectedVariant = only;
      if (addBtn) addBtn.disabled = !only.available;
      return;
    }

    var sizeIdx = getSizeOptionIndex(product);
    var key = 'option' + (sizeIdx + 1);
    var seen = {};
    var firstAvailable = null;
    product.variants.forEach(function (variant) {
      var val = variant[key];
      if (!val || seen[val]) return;
      seen[val] = true;
      var matched = findVariantForSize(product, card, val, sizeIdx) || variant;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-picker__size-option';
      btn.textContent = val;
      btn.disabled = !(matched && matched.available);
      btn.addEventListener('click', function () { selectSizeVariant(matched, btn); });
      optionsEl.appendChild(btn);
      if (matched && matched.available && !firstAvailable) firstAvailable = { variant: matched, btn: btn };
    });

    if (firstAvailable) selectSizeVariant(firstAvailable.variant, firstAvailable.btn);
  }
  function openBundleSizeModal(card) {
    var modal = sizeModalEl();
    if (!modal || !card) return;
    var handle = card.getAttribute('data-product-handle') || card.dataset.productHandle;
    var title = card.getAttribute('data-product-title') || card.dataset.productTitle || '';
    var hasChart = card.getAttribute('data-size-chart-available') === 'true' || !!q('[data-bundle-size-chart]', card);
    var addBtn = card.querySelector('[data-bundle-add-btn]');
    if (!handle) {
      tip('Could not open size options. Please refresh the page.');
      return;
    }
    if (addBtn) {
      addBtn.classList.add('loading');
      addBtn.disabled = true;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.json();
      })
      .then(function (product) {
        sizeModalState.card = card;
        sizeModalState.product = product;
        sizeModalState.chartLoaded = false;
        closeSizeChartDrawer();

        var titleEl = q('[data-bundle-size-modal-title]', modal);
        var chartLink = q('[data-bundle-size-chart-link]', modal);
        if (titleEl) titleEl.textContent = product.title || title;
        if (chartLink) {
          if (hasChart) {
            chartLink.hidden = false;
            chartLink.setAttribute('aria-expanded', 'false');
          } else {
            chartLink.hidden = true;
          }
        }

        renderSizeModalOptions(product, card);
        modal.hidden = false;
        document.documentElement.classList.add('hypd-bundle-size-modal-open');
        var first = q('[data-bundle-size-modal-options] .bundle-picker__size-option:not(:disabled)', modal);
        if (first) first.focus();
      })
      .catch(function () {
        tip('Could not load product sizes. Please try again.');
      })
      .finally(function () {
        if (addBtn) {
          addBtn.classList.remove('loading');
          addBtn.disabled = picked.length >= active.count;
        }
      });
  }
  function bindSizeModal() {
    if (root.dataset.sizeModalBound === '1') return;
    root.dataset.sizeModalBound = '1';
    document.addEventListener('click', function (e) {
      var modal = sizeModalEl();
      if (e.target.closest('[data-bundle-size-chart-close], [data-bundle-chart-overlay]')) {
        e.preventDefault();
        closeSizeChartDrawer();
        return;
      }
      if (!modal || modal.hidden) return;
      if (e.target.closest('[data-bundle-size-modal-close]')) {
        e.preventDefault();
        closeSizeModal();
        return;
      }
      if (e.target.closest('[data-bundle-size-chart-link]')) {
        e.preventDefault();
        if (sizeModalState.card) openSizeChartDrawer(sizeModalState.card);
        return;
      }
      if (e.target.closest('[data-bundle-size-modal-add]')) {
        e.preventDefault();
        if (!sizeModalState.selectedVariant) return tip('Please select a size.');
        addVariantToBundle(sizeModalState.selectedVariant, sizeModalState.product, sizeModalState.card);
      }
    });
    document.addEventListener('keydown', function (e) {
      var drawer = sizeChartDrawer();
      if (drawer && drawer.classList.contains('is-opened') && e.key === 'Escape') {
        closeSizeChartDrawer();
        return;
      }
      var modal = sizeModalEl();
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') closeSizeModal();
    });
  }
  function syncQvAddBtn() {
    var qv = document.getElementById('Quick-view');
    if (!qv || !qv.classList.contains('hypd-bundle-quick-view')) return;
    var form = qv.querySelector('product-form[data-product-id]');
    if (!form) return;
    var full = picked.length >= active.count;
    var lbl = bundleAddLabel();
    var soldOut = qvSoldOutLabel();
    var available = qvBundleCanAdd(qv);
    var a = qv.querySelector('[data-bundle-add-label]');
    var b = qv.querySelector('[data-bundle-added-label]');
    var btn = qv.querySelector('[data-hypd-bundle-qv-add]');
    if (full) {
      if (a) { a.textContent = lbl; a.hidden = false; }
      if (b) b.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-label', lbl);
      }
      return;
    }
    if (!available) {
      if (a) { a.textContent = soldOut; a.hidden = false; }
      if (b) b.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.removeAttribute('data-bundle-add-btn');
        btn.setAttribute('aria-label', soldOut);
      }
      return;
    }
    if (a) { a.textContent = lbl; a.hidden = false; }
    if (b) b.hidden = true;
    if (btn) {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.setAttribute('data-bundle-add-btn', '');
      btn.setAttribute('aria-label', lbl);
    }
  }
  function waitSR(ms) {
    return new Promise(function (res, rej) {
      var t0 = Date.now();
      (function go() {
        if (window.HeadlessCheckout && window.HeadlessCheckout.checkout) return res(window.HeadlessCheckout);
        if (window.shiprocketCheckoutEvents && window.shiprocketCheckoutEvents.buyCart) return res(window.shiprocketCheckoutEvents);
        var b = document.querySelector('.shiprocket-headless[data-type="mini-cart"] .sr-headless-checkout,.shiprocket-headless[data-type="cart"] .sr-headless-checkout');
        if (b) return res({ clickHost: b });
        if (Date.now() - t0 > ms) return rej(new Error('Shiprocket checkout is not ready. Please refresh and try again.'));
        setTimeout(go, 80);
      })();
    });
  }
  function ensureBundleCartAttributes() {
    var attrs = {
      bundle_source: 'bundle_page',
      hypd_bundle_checkout: '1',
      hypd_bundle_tier: String(active.id),
      hypd_bundle_qty: String(active.count),
    };
    if (C && C.setBundleCartAttributes) return C.setBundleCartAttributes(attrs);
    return fetch(window.routes.cart_url + '/update.js', {
      method: 'POST',
      headers: hdr,
      body: JSON.stringify({ attributes: attrs }),
    });
  }
  function ensureBundleUtm() {
    try {
      var utm = { utm_source: 'hypd_bundle', utm_medium: 'bundle_page', utm_campaign: 'bundle_checkout' };
      sessionStorage.setItem('hypd_bundle_utm', JSON.stringify(utm));
      var u = new URL(location.href);
      if (!u.searchParams.get('utm_source')) {
        u.searchParams.set('utm_source', utm.utm_source);
        u.searchParams.set('utm_medium', utm.utm_medium);
        u.searchParams.set('utm_campaign', utm.utm_campaign);
        history.replaceState(null, '', u.toString());
      }
    } catch (e) {}
  }
  function logBundleCart(cart) {
    if (!cart || typeof console === 'undefined' || !console.log) return cart;
    var a = cart.attributes || {};
    console.log('[HYPD Bundle] cart for checkout', {
      attributes: a,
      items: cart.items ? cart.items.length : 0,
      line0: cart.items && cart.items[0] ? cart.items[0].properties : null,
    });
    if (a.bundle_source !== 'bundle_page') {
      console.warn('[HYPD Bundle] bundle_source missing on cart — Shiprocket attribute criteria may not apply.');
    }
    return cart;
  }
  function delay(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }
  function bundleCouponCode() {
    var cfg = window.HypdCartConfig || {};
    return (cfg.bundleDiscountCode || '').trim();
  }
  function applyBundleCoupon() {
    var code = bundleCouponCode();
    if (!code) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.routes && window.routes.root_url) || '/';
    var url = root.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code);
    return fetch(url, { method: 'GET', credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
  }
  function goCheckout() {
    var code = bundleCouponCode();
    var ev = { preventDefault: function () {}, stopPropagation: function () {} };
    if (code) {
      ev.discountCode = code;
      ev.couponCode = code;
      ev.discount = code;
    }
    return waitSR(12000).then(function (api) {
      if (api.checkout) return api.checkout(ev);
      if (api.buyCart) return api.buyCart(ev, ev);
      if (api.clickHost) api.clickHost.click();
    });
  }
  function refreshCart() {
    if (!C || !window.routes || !window.routes.cart_url) return Promise.resolve();
    return C.fetch().then(function (cart) {
      C.updateHeader(cart);
      var d = document.querySelector('cart-drawer#CartDrawer,cart-drawer');
      if (!d) return;
      if (cart.items && cart.items.length && !C.visibleQty(cart)) { d.setAttribute('data-hypd-cart-bundle-only', ''); d.hide && d.hide(); }
      else d.removeAttribute('data-hypd-cart-bundle-only');
    }).catch(function () {});
  }
  async function checkout() {
    if (picked.length !== active.count || !window.routes || !window.routes.cart_add_url) return;
    var f = foot();
    var btn = f && q('[data-bundle-checkout]', f);
    var lbl = (btn && btn.dataset.defaultLabel) || 'Checkout';
    function setLbl(t) {
      if (!btn) return;
      var el = q('[data-bundle-checkout-text]', btn);
      el ? (el.textContent = t) : (btn.textContent = t);
    }
    if (btn) { btn.disabled = true; setLbl('Adding…'); }
    try {
      await fetch(window.routes.cart_url + '/clear.js', { method: 'POST', headers: hdr });
      await ensureBundleCartAttributes();
      var res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: hdr,
        body: JSON.stringify({ items: picked.map(function (p) {
          return {
            id: +p.variantId,
            quantity: 1,
            properties: {
              _hypd_bundle: '1',
              bundle_source: 'bundle_page',
              _bundle_collection: col,
              _bundle_tier: String(active.id),
              _bundle_size: String(active.count),
            },
          };
        }) }),
      });
      var st = await res.json();
      if ((st.status && st.status >= 400) || st.description) throw new Error(st.message || st.description || 'Cart error');
      await ensureBundleCartAttributes();
      var cart = C && C.fetch ? await C.fetch() : await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      logBundleCart(cart);
      setLbl('Please wait…');
      var d = document.querySelector('cart-drawer#CartDrawer,cart-drawer');
      if (d && d.hide) try { await d.hide(); } catch (e) {}
      await applyBundleCoupon();
      await delay(400);
      try { await goCheckout(); }
      catch (e) { window.location.href = ((window.routes.root_url || '/') + '/').replace(/\/?$/, '/') + 'checkout'; return; }
      if (btn) { setLbl(lbl); btn.disabled = picked.length !== active.count; }
    } catch (e) {
      tip(e.message || 'Could not add to cart');
      if (btn) { setLbl(lbl); btn.disabled = picked.length !== active.count; }
    }
  }
  function onReturn() { (C ? C.clearBundle() : Promise.resolve()).then(refreshCart).catch(refreshCart); }
  function guard() {
    if (!C || !C.isBundlePage()) return;
    document.addEventListener('click', function (e) {
      if (!C.isBundlePage()) return;
      var t = e.target.closest('[data-sidebar-id="CartDrawer"],[data-sidebar-button][data-sidebar-id="CartDrawer"],#CartCount,#StickyCartCount,.header__cart,a[href="/cart"],a[href$="/cart"]');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      C.clearBundle().then(function () { var d = document.querySelector('cart-drawer'); d && d.hide && d.hide(); });
    }, true);
    C.clearBundle();
    window.addEventListener('pageshow', function () { C.clearBundle(); var d = document.querySelector('cart-drawer'); d && d.hide && d.hide(); });
  }
  function markBundleQuickView() {
    var qv = document.getElementById('Quick-view');
    if (qv) qv.classList.add('hypd-bundle-quick-view');
  }
  function unmarkBundleQuickView() {
    var qv = document.getElementById('Quick-view');
    if (!qv) return;
    qv.classList.remove('hypd-bundle-quick-view');
    delete qv.dataset.hypdBundleQvSetup;
    delete qv.dataset.hypdBundleQvVariantBound;
  }
  function hideQvBuyNow() {
    var qv = document.getElementById('Quick-view');
    if (!qv || !qv.classList.contains('hypd-bundle-quick-view')) return;
    qa('.dynamic-checkout-buttons, .shiprocket-headless, .sr-headless-checkout, button.sr-headless-checkout', qv).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    qa('.product-form__view-details-link, .product__info > a.link', qv).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    qa('.product-quantity__wrap, quantity-component.product-quantity__quantity', qv).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }
  function setupBundleQuickView() {
    var qv = document.getElementById('Quick-view');
    if (!qv || !qv.classList.contains('hypd-bundle-quick-view')) return false;
    hideQvBuyNow();
    qa('.hypd-bundle-pdp-notice', qv).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    var formWrap = qv.querySelector('product-form[data-product-id]');
    var btns = q('.product-form__btns', qv);
    if (!btns) {
      var notice = q('.hypd-bundle-pdp-notice', qv);
      if (notice && !formWrap) return false;
      if (!formWrap) return false;
      btns = document.createElement('div');
      btns.className = 'product-form__btns product-form__btns--hypd-bundle-qv';
      var form = formWrap.querySelector('form') || formWrap;
      if (form && form.appendChild) form.appendChild(btns);
      else return false;
    }
    qa('.product-form__btns button[type="submit"][name="add"], product-form-button', qv).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    var lbl = bundleAddLabel();
    var boxBtn = q('[data-hypd-bundle-qv-add], [data-bundle-add-btn]', qv);
    if (!boxBtn || !boxBtn.hasAttribute('data-hypd-bundle-qv-add')) {
      var canAdd = qvBundleCanAdd(qv);
      var soldOut = qvSoldOutLabel();
      var wrap = document.createElement('div');
      wrap.className = 'product-form__btn-wrapper hypd-bundle-qv-add';
      wrap.innerHTML = canAdd
        ? '<button type="button" class="product-form__btn btn btn--lg btn--solid product-card__btn--bundle-add" data-bundle-add-btn data-hypd-bundle-qv-add aria-label="' +
          lbl.replace(/"/g, '&quot;') +
          '"><span data-bundle-add-label>' +
          lbl +
          '</span><span data-bundle-added-label hidden>Added</span></button>'
        : '<button type="button" class="product-form__btn btn btn--lg btn--solid product-card__btn--bundle-add" data-hypd-bundle-qv-add disabled aria-disabled="true" aria-label="' +
          soldOut.replace(/"/g, '&quot;') +
          '"><span data-bundle-add-label>' +
          soldOut +
          '</span></button>';
      btns.appendChild(wrap);
      boxBtn = q('[data-hypd-bundle-qv-add]', qv);
    }
    if (boxBtn) {
      boxBtn.style.setProperty('display', 'inline-flex', 'important');
      boxBtn.style.setProperty('visibility', 'visible', 'important');
      boxBtn.style.setProperty('width', '100%', 'important');
      var wrapEl = boxBtn.closest('.hypd-bundle-qv-add, .product-form__btn-wrapper');
      if (wrapEl) {
        wrapEl.style.setProperty('display', 'block', 'important');
        wrapEl.style.setProperty('width', '100%', 'important');
      }
    }
    var form = qv.querySelector('form[data-type="add-to-cart-form"]');
    if (form && form.dataset.hypdQvGuard !== '1') {
      form.dataset.hypdQvGuard = '1';
      form.addEventListener('submit', function (e) {
        if (qv.classList.contains('hypd-bundle-quick-view')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }
    bindBundleQvVariantSync(qv);
    syncQvAddBtn();
    setTimeout(function () { syncQvAddBtn(); }, 0);
    setTimeout(function () { syncQvAddBtn(); }, 300);
    qv.dataset.hypdBundleQvSetup = '1';
    return true;
  }
  function scheduleBundleQuickViewSetup() {
    var qv = document.getElementById('Quick-view');
    if (!qv || !qv.classList.contains('hypd-bundle-quick-view')) return;
    delete qv.dataset.hypdBundleQvSetup;
    clearTimeout(scheduleBundleQuickViewSetup._t);
    var attempt = 0;
    function tick() {
      attempt += 1;
      if (setupBundleQuickView()) return;
      if (attempt < 30) scheduleBundleQuickViewSetup._t = setTimeout(tick, 150);
    }
    scheduleBundleQuickViewSetup._t = setTimeout(tick, 100);
  }
  function watchQuickView() {
    var qv = document.getElementById('Quick-view');
    if (!qv || qv.dataset.hypdBundleQvWatch === '1') return;
    qv.dataset.hypdBundleQvWatch = '1';
    var contentTimer;
    new MutationObserver(function (mutations) {
      if (!qv.classList.contains('hypd-bundle-quick-view')) return;
      var added = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { added = true; break; }
      }
      if (!added) return;
      clearTimeout(contentTimer);
      contentTimer = setTimeout(scheduleBundleQuickViewSetup, 120);
    }).observe(qv, { childList: true, subtree: true });
    new MutationObserver(function () {
      if (qv.hasAttribute('is-open')) {
        if (qv.classList.contains('hypd-bundle-quick-view')) scheduleBundleQuickViewSetup();
      } else {
        unmarkBundleQuickView();
      }
    }).observe(qv, { attributes: true, attributeFilter: ['is-open'] });
  }
  function bindBundleCardNav() {
    if (root.dataset.bundleNavBound === '1') return;
    root.dataset.bundleNavBound = '1';
    root.addEventListener(
      'click',
      function (e) {
        var card = e.target.closest('product-card[data-bundle-card]');
        if (!card || !root.contains(card)) return;
        var link = e.target.closest('a[href]');
        if (link && card.contains(link)) {
          var href = link.getAttribute('href') || '';
          if (href.indexOf('/products/') !== -1 || href.indexOf('/collections/') !== -1) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        }
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        var qv = document.getElementById('Quick-view');
        if (!qv || !qv.classList.contains('hypd-bundle-quick-view')) return;
        var link = e.target.closest('#Quick-view a[href]');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/products/') !== -1 || href.indexOf('/collections/') !== -1) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }
  function bindSlotsRowGuard() {
    if (root.dataset.slotsRowGuard === '1') return;
    root.dataset.slotsRowGuard = '1';
    var touchStartX = 0;
    var touchStartY = 0;
    root.addEventListener(
      'touchstart',
      function (e) {
        if (!e.target.closest('[data-bundle-slots]')) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true, capture: true }
    );
    root.addEventListener(
      'touchmove',
      function (e) {
        var row = e.target.closest('[data-bundle-slots]');
        if (!row) return;
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > dy && dx > 8) e.preventDefault();
      },
      { passive: false, capture: true }
    );
  }
  function bind() {
    document.body.classList.add('has-bundle-picker-footer', 'template-page-bundle');
    bindSizeModal();
    bindBundleCardNav();
    bindSlotsRowGuard();
    watchQuickView();
    qa(sectionSel + ' [data-bundle-tier]').forEach(function (b) { b.addEventListener('click', function () { setTier(+b.getAttribute('data-bundle-tier')); }); });
    var f = foot();
    if (f && f.dataset.bundleBound !== '1') {
      f.dataset.bundleBound = '1';
      f.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-bundle-remove]');
        if (!rm) return;
        e.preventDefault();
        var ix = +rm.getAttribute('data-bundle-remove');
        if (!isNaN(ix)) { picked.splice(ix, 1); persist(); paint(); }
      });
    }
    var btn = f && q('[data-bundle-checkout]', f);
    if (btn && btn.dataset.bundleCheckoutBound !== '1') { btn.dataset.bundleCheckoutBound = '1'; btn.addEventListener('click', checkout); }
    if (root.dataset.bundleQvBound !== '1') {
      root.dataset.bundleQvBound = '1';
      document.addEventListener('click', function (e) {
        var qvBtn = e.target.closest('[data-product-card-quick-view-button]');
        if (qvBtn && qvBtn.closest(sectionSel)) {
          markBundleQuickView();
          scheduleBundleQuickViewSetup();
        }
      }, true);
    }
    if (root.dataset.bundleClickBound !== '1') {
      root.dataset.bundleClickBound = '1';
      document.addEventListener('click', function (e) {
        var minusBtn = e.target.closest('[data-bundle-qty-minus]');
        if (minusBtn) {
          if (!minusBtn.closest(sectionSel)) return;
          var minusCard = minusBtn.closest('[data-bundle-card],product-card');
          if (!minusCard) return;
          e.preventDefault();
          e.stopPropagation();
          if (removeLastPickedForProduct(cardProductId(minusCard))) {
            persist();
            paint();
          }
          return;
        }
        var plusBtn = e.target.closest('[data-bundle-qty-plus]');
        if (plusBtn) {
          if (!plusBtn.closest(sectionSel)) return;
          var plusCard = plusBtn.closest('[data-bundle-card],product-card');
          if (!plusCard) return;
          e.preventDefault();
          e.stopPropagation();
          if (picked.length >= active.count) return tip('You can only add ' + active.count + ' items to this bundle.');
          if (bundlePopup) openBundleSizeModal(plusCard);
          else add(plusCard);
          return;
        }
        var addBtn = e.target.closest('[data-bundle-add-btn]');
        if (!addBtn) return;
        if (addBtn.closest('#Quick-view')) {
          e.preventDefault();
          e.stopPropagation();
          addFromQuickView();
          return;
        }
        if (!e.target.closest(sectionSel)) return;
        e.preventDefault();
        e.stopPropagation();
        var card = addBtn.closest('[data-bundle-card],product-card');
        if (card) {
          if (bundlePopup) openBundleSizeModal(card);
          else add(card);
        }
      }, true);
    }
    if (!window['hypdBundleCartSync_' + sectionId]) {
      window['hypdBundleCartSync_' + sectionId] = true;
      window.addEventListener('pageshow', onReturn);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') onReturn(); });
    }
  }
  function initBenefitsMarquee() {
    var wrap = q(sectionSel + ' [data-bundle-benefits]');
    var track = wrap && q('[data-bundle-benefits-track]', wrap);
    if (!wrap || !track) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var label = wrap.getAttribute('aria-label') || '';
    var first = q('.bundle-picker__benefits-item', track);
    if (!label && first) label = first.textContent.trim();
    if (!label) return;

    function makeItem(hidden) {
      var el = document.createElement('span');
      el.className = 'bundle-picker__benefits-item body3';
      el.textContent = label;
      if (hidden) el.setAttribute('aria-hidden', 'true');
      return el;
    }

    track.innerHTML = '';
    track.appendChild(makeItem(false));
    var guard = 0;
    while (track.scrollWidth < wrap.offsetWidth * 2 && guard < 24) {
      track.appendChild(makeItem(true));
      guard += 1;
    }
    var baseCount = track.children.length;
    var i;
    for (i = 0; i < baseCount; i++) {
      track.appendChild(makeItem(true));
    }

    var loopWidth = track.scrollWidth / 2;
    if (loopWidth <= 0) return;
    track.style.setProperty('--benefits-scroll-distance', '-' + loopWidth + 'px');
    track.style.setProperty('--benefits-scroll-duration', Math.max(14, loopWidth / 70) + 's');
    track.dataset.marqueeReady = '1';
  }
  function start() {
    ensureBundleUtm();
    var f = document.getElementById(footerId);
    if (!f) { document.documentElement.classList.add('hypd-bundle-ready'); document.documentElement.classList.remove('hypd-bundle-loading'); return; }
    restore();
    qa(sectionSel + ' [data-bundle-tier]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-bundle-tier') === String(active.id) ? 'true' : 'false'); });
    setHead(active);
    bind();
    guard();
    paint();
    window.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = true;
      requestAnimationFrame(function () { syncBar(); scrollRaf = false; });
    }, { passive: true });
    window.addEventListener('resize', function () {
      dock();
      var track = q(sectionSel + ' [data-bundle-benefits-track]');
      if (track) delete track.dataset.marqueeReady;
      initBenefitsMarquee();
    }, { passive: true });
    requestAnimationFrame(function () {
      dock();
      initBenefitsMarquee();
      document.documentElement.classList.add('hypd-bundle-ready');
      document.documentElement.classList.remove('hypd-bundle-loading');
    });
    (C ? C.clearBundle() : Promise.resolve()).then(refreshCart).catch(refreshCart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id === 'shopify-section-' + sectionId) { restore(); setHead(active); paint(); dock(); initBenefitsMarquee(); }
  });
})();
